import React, {FC, ReactNode, useEffect} from 'react';
import {ConfigApi} from "../../services/Api/types";
import StoreUtils from "../../services/Store/StoreUtils";


interface Props {
    children?: ReactNode;
    config?: ConfigApi
}


const bodyClass = "body-cart-sticky"
const orderModeReadonlyBodyClass = "body-order-readonly"
const CartStickyContextPage: FC<Props> = (props) => {
    useEffect(() => {
        if (bodyClass) {
            document.body.classList.add(bodyClass);
        }
        if (StoreUtils.isOrderingReadonly(props.config)) {
            document.body.classList.add(orderModeReadonlyBodyClass);
        }

        return () => {
            if (bodyClass) {
                document.body.classList.remove(bodyClass);
            }
            if (StoreUtils.isOrderingReadonly(props.config)) {
                document.body.classList.remove(orderModeReadonlyBodyClass);
            }
        };
    }, [bodyClass]);

    return (
        <>{props.children}</>
    )
};

export default CartStickyContextPage;
